export enum ImportsColumns {
  BANK_ACCOUNT = "bank_account",
  USER = "user",
  TRANSACTIONS_SUCCESS_COUNT = "success_transactions_count",
  TRANSACTIONS_SUCCESS_AMOUNT = "success_transactions_amount",
  TRANSACTIONS_SUCCESS_AMOUNT_WITH_FEE = "success_transactions_amount_with_fee",
  TRANSACTIONS_FAILED_COUNT = "failed_transactions_count",
  TRANSACTIONS_FAILED_AMOUNT = "failed_transactions_amount",
  CREATED_AT = "created_at",
  STATUS = "status",
  ACTIONS = "actions",
}

export const all = Object.keys(ImportsColumns).filter((item) => {
  return isNaN(Number(item));
});
